<div class="col-12">
  <div class="card">
    <div class="card-header" style="padding-bottom: 0">
      <h4 class="modal-title">
        {{ 'AddOrganization' | translate }}
        <app-help hrefKey="ExternalHelp.organizations" />
      </h4>
      <p style="margin-top: 10px">{{ 'AddAccountTooltip' | translate }}</p>
      <hr />
    </div>
    <div *ngIf="organization" class="card-body" style="padding-top: 0">
      <div class="row">
        <div class="col-xl-6">
          <div class="form-group">
            <label for="name" class="star" [innerHtml]="'Nom' | translate"></label>
            <input id="name" [(ngModel)]="organization.name" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label for="country" [innerHtml]="'Pays' | translate"></label>
            <select id="country" name="countries" class="form-control" [(ngModel)]="organization.countryCode">
              <option *ngFor="let p of countries" [value]="p.code">{{ p.name }}</option>
            </select>
          </div>
          <div *featureFlag="'mfaOrg'" class="form-group">
            <app-label label="RequireMFA" />
            <app-switch
              [(ngModel)]="organization.requireMfa"
              [highlightActiveLabel]="true"
              [showLabels]="true"
              id="mfa"
            ></app-switch>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="form-group">
            <label for="city" [innerHtml]="'Ville' | translate"></label>
            <input id="city" [(ngModel)]="organization.city" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label for="zip-code" [innerHtml]="'CodePostal' | translate"></label>
            <input id="zip-code" [(ngModel)]="organization.zipCode" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label for="street" [innerHtml]="'Rue' | translate"></label>
            <input id="street" [(ngModel)]="organization.street" type="text" class="form-control" />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="organization" class="card-footer">
      <button
        id="submitAdd"
        [disabled]="!canValidate()"
        (click)="onCreate()"
        class="btn btn-sm btn-primary mr-2"
        [innerHtml]="'ajouter' | translate"
      ></button>
      <button
        (click)="organization = emptyOrganization(); back()"
        class="btn btn-sm btn-danger"
        [innerHtml]="'Annuler' | translate"
      ></button>
    </div>
  </div>
</div>
